import { createSlice } from "@reduxjs/toolkit";

export const devolutionActions = createSlice({
  name: "TicketDevolutions",
  initialState: {
    value: {
        equipmentNotPreScheduled: [],
        equipmenPreScheduled: [],
        proposalSugar: [],
        proposalCnpj: ''
    },
  },
  
  reducers: {
    updateEquipementNotPreScheduled(state, { payload }) {
        state.value.equipmentNotPreScheduled = payload
        console.log("updateEquipmentNotPreScheduled " + state.value.equipmentNotPreScheduled.length);
    },
    updateEquipmentPreScheduled(state, { payload }) {
        console.log("updateEquipmentPreScheduled " + state.value.equipmenPreScheduled.length);
        state.value.equipmenPreScheduled = payload;
    },
    setProposalSugar(state, {payload}){
      state.value.proposalSugar = payload
    },
    setProposalCnpj(state, {payload}) {
      state.value.proposalCnpj = payload
    }
  },
});

export const {
  updateEquipementNotPreScheduled,
  updateEquipmentPreScheduled,
  setProposalSugar,
  setProposalCnpj
} = devolutionActions.actions;

export default devolutionActions.reducer;
